<template>
    <div v-if="!loading" class="pb-50">
        <b-card>
            <div class="d-flex justify-content-md-between align-items-center flex-md-row flex-column">
                <div class="text-center text-md-left">
                    <h4 class="mb-1">
                        تنظیمات پیامک : <span :class="hasPendingTemplate ? 'text-warning' : 'text-success'">
                            {{ hasPendingTemplate ? "در حال بررسی" : "فعال" }}
                        </span>
                    </h4>
                    <h5 class="mb-0">
                        آخرین تغییرات :
                        <span>
                            {{ new Date(lastModifiedAt).toLocaleTimeString('fa-IR') }}
                        </span>
                        <span> - </span>
                        <span>
                            {{ new Date(lastModifiedAt).toLocaleDateString('fa-IR') }}
                        </span>
                    </h5>
                </div>
                <div class="mt-2 mt-md-0">
                    <b-button @click="smsManagementStoreAccept" :disabled="!hasPendingTemplate" variant="primary"
                        class="px-4">
                        تایید
                    </b-button>
                </div>
            </div>
            <b-row>
                <b-col v-for="(item, index) in smsManagementStoreData" :key="index" md="6">
                    <div class="mt-2">
                        <h4>{{ item.name }}</h4>
                        <b-form-textarea v-model="item.message" rows="6" disabled no-resize></b-form-textarea>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>

</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BFormInput, BFormTextarea, BFormRadio } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BFormInput,
        BFormRadio,
        BFormTextarea
    },
    data() {
        return {
            loading: true,
            storeId: null,
            smsManagementStoreData: [],
            hasPendingTemplate: null,
            lastModifiedAt: null,
        };
    },
    methods: {
        smsManagementStore() {
            adminService.smsManagementStore(this.storeId).then(({ data }) => {
                this.hasPendingTemplate = data.hasPendingTemplate
                this.lastModifiedAt = data.lastModifiedAt
                this.smsManagementStoreData = []
                this.smsManagementStoreData = data.templates.map(item => ({
                    ...item,
                    message: item.pendingCustomMessage ? item.pendingCustomMessage : item.customMessage
                }))
                this.loading = false
            })
        },
        smsManagementStoreAccept() {
            let data = {
                storeId: this.storeId,
                lastModifiedAt: this.lastModifiedAt
            }
            adminService.smsManagementStoreAccept(data).then(({ }) => {
                this.smsManagementStore();
            })
        },
    },
    mounted() {
        this.storeId = this.$route.query.id;
        this.smsManagementStore();
    },
};
</script>
